import React from 'react';
import { FormikProps, withFormik } from 'formik';

import { Admin, adminFactory } from '@/types/admin';
import { adminSchema } from '@/services/validators/admin';
import { FormContents, Values } from './FormContents';

type OuterProps = {
  admin: Admin;
  isLoading: boolean;
  onSubmit: (admin: Admin) => void;
};

export const NameEditForm = withFormik<OuterProps, Values>({
  mapPropsToValues: ({ admin }: OuterProps) => ({
    firstName: admin?.firstName ?? '',
    lastName: admin?.lastName ?? '',
    kanaFirstName: admin?.kanaFirstName ?? '',
    kanaLastName: admin?.kanaLastName ?? '',
  }),
  validationSchema: adminSchema,
  handleSubmit: (values, { props, setSubmitting }) => {
    const admin = adminFactory({
      id: props.admin.id,
      firstName: values.firstName,
      lastName: values.lastName,
      kanaFirstName: values.kanaFirstName,
      kanaLastName: values.kanaLastName,
    });
    props.onSubmit(admin);
    setSubmitting(false);
  },
  enableReinitialize: true,
})(
  // enhanced form
  ({
    errors,
    handleChange,
    handleSubmit,
    isLoading,
    dirty,
    isSubmitting,
    touched,
    values,
  }: OuterProps & FormikProps<Values>) => {
    return (
      <FormContents
        errors={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        dirty={dirty}
        isSubmitting={isSubmitting}
        touched={touched}
        values={values}
      />
    );
  },
);
